module.exports = __webpack_public_path__ + "static/media/QS.9026849b.png";